'use strict';

function CnQuestionnaireWizardController($q) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.$onChanges = $onChanges;
  vm._makeStep = _makeStep;
  vm.move = move;

  function $onInit() {
    vm.current = vm.current || 1;
    vm.max = vm.max || 0;
    vm.answers = vm.answers || [];
    vm.onChange = vm.onChange() || $q.resolve;
    vm.active = false;
    vm.locked = vm.locked === true;
    vm.hideCompleted = vm.hideCompleted === true;
  }

  function $onChanges(changes) {
    if (changes.answers && changes.answers.currentValue.length) {
      vm.steps = changes.answers.currentValue.map(vm._makeStep);
    }
  }

  function move(to) {
    if (!vm.locked) {
      vm.active = true;
      return vm.onChange(to).finally(function() { vm.active = false; });
    }
  }

  function _makeStep(item, index) {
    return {
      active: (vm.current - 1) === index,
      state: item.state
    };
  }
}

module.exports = CnQuestionnaireWizardController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-questionnaire-wizard/cn-questionnaire-wizard.controller.js
 ** module id = 109
 ** module chunks = 0
 **/